//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/TransientObject.js";
let d=[[[0,"NumberUnsavedObjects",0,0],[0,"NumberUnsavedParts",0,0]],[[[],"Dispose",{},0,0],[["i"],"GetPart",{R_:{part_name:"BasePart"}},1,0],[["i"],"GetStatus",{R_:{status:''}},1,0],[["i"],"GetObjectStatus",{R_:{status:''}},1,0],[["num_parts","parts_statuses","num_objects","objects_statuses"],"GetAllStatuses",{},0,0]],[]];
SPLM.PartSaveStatus = class extends SPLM.TransientObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.PartSaveStatus";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.PartSaveStatus.PartStatus = class{
    constructor(part,status,description){
        this.part=part;this.status=status;this.description=description;}
    get Part(){return this.part}
    set Part(val){this.part = val}
    get Status(){return this.status}
    set Status(val){this.status = val}
    get Description(){return this.description}
    set Description(val){this.description = val}
};

SPLM.PartSaveStatus.ObjectStatus = class{
    constructor(obj,status,description){
        this.obj=obj;this.status=status;this.description=description;}
    get Obj(){return this.obj}
    set Obj(val){this.obj = val}
    get Status(){return this.status}
    set Status(val){this.status = val}
    get Description(){return this.description}
    set Description(val){this.description = val}
};

export default SPLM;